import { createReducer, on } from '@ngrx/store';

import { AppleProfilePresetApiActions, AppleProfilePresetViewActions } from './apple-profile-preset.actions';
import { adapter, createPresetId, initialState, selectId } from './apple-profile-preset.state';

export const APPLE_PROFILE_PRESET_FEATURE_KEY = 'apple-profile-presets';

export const appleProfilePresetReducer = createReducer(
  initialState,
  on(AppleProfilePresetApiActions.presetsLoaded, (state, { profileType, presets }) => {
    const entries = presets.map((preset) => ({ profileType, preset }));
    return adapter.upsertMany(entries, state);
  }),
  on(
    AppleProfilePresetApiActions.presetUpdated,
    AppleProfilePresetApiActions.presetUpdatedError,
    AppleProfilePresetApiActions.presetDeletedError,
    AppleProfilePresetViewActions.presetUpdated,
    (state, { profileType, preset }) => {
      return adapter.upsertOne({ profileType, preset }, state);
    }
  ),
  on(AppleProfilePresetApiActions.presetAdded, (state, { profileType, preset }) => {
    const optimisticKey = createPresetId(profileType, preset.id);
    const stateWithoutOptimistic = adapter.removeOne(optimisticKey, state);
    return adapter.upsertOne({ profileType, preset }, stateWithoutOptimistic);
  }),
  on(AppleProfilePresetViewActions.presetAdded, (state, { profileType, preset }) => {
    return adapter.upsertOne({ profileType, preset: { ...preset, uniqueId: preset.id } }, state);
  }),
  on(
    AppleProfilePresetApiActions.presetDeleted,
    AppleProfilePresetViewActions.presetDeleted,
    (state, { profileType, preset }) => {
      return adapter.removeOne(selectId({ profileType, preset }), state);
    }
  ),
  on(AppleProfilePresetApiActions.presetAddedError, (state, { profileType, preset }) => {
    return adapter.removeOne(selectId({ profileType, preset }), state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAppleProfilePresetIds = selectIds;

export const selectAppleProfilePresetEntities = selectEntities;

export const selectAllAppleProfilePresets = selectAll;
